import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "flex items-center justify-center mb-0.5" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "font-semibold text-xs whitespace-nowrap flex items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_base_svg_icon, {
        class: _normalizeClass(["w-6", _ctx.iconClass]),
        path: _ctx.path
      }, null, 8, ["class", "path"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", null, _toDisplayString(_ctx.text), 1),
        (_ctx.open)
          ? (_openBlock(), _createBlock(_component_base_svg_icon, {
              key: 0,
              class: "w-4 ml-0.5",
              path: _ctx.mdiOpenInNew
            }, null, 8, ["path"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}